import React from 'react';
import { useSelector } from 'react-redux';
import { ModalTasksMonth } from './ui/ModalTasksMonth/ModalTasksMonth';
import { ModalAddNewTask } from './ui/ModalAddNewTask';
import { ModalEditTask } from './ui/ModalEditTask';

export const TasksModal = ({ portalFileOverlays = false }: { portalFileOverlays?: boolean }) => {
    //@ts-ignore
    const { modalMode } = useSelector((store) => store.taskBoardReducer);

    return (
        <>
            {modalMode === 'tasksMonth' && <ModalTasksMonth />}
            {modalMode === 'addNewTask' && (
                <ModalAddNewTask portalFileOverlays={portalFileOverlays} />
            )}
            {modalMode === 'editTask' && <ModalEditTask portalFileOverlays={portalFileOverlays} />}
        </>
    );
};
